import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_DeliveryNotes } from "./SIV_DeliveryNotes";
import type { SIV_GoodsReceiptProcess } from "./SIV_GoodsReceiptProcess";
import type { SIV_Order } from "./SIV_Order";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_GoodsReceivingAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  amount?: number | undefined;
  changedAt?: Date | undefined;
  changedBy?: _User | undefined;
  date?: Date | undefined;
  deliveryNote?: SIV_DeliveryNotes | undefined;
  description?: string | undefined;
  directory?: string | undefined;
  directoryDate?: Date | undefined;
  filler?: string | undefined;
  goodsReceiptProcess?: SIV_GoodsReceiptProcess | undefined;
  no: string;
  notFoundValues: any;
  order: SIV_Order;
  project?: string | undefined;
  storageLocation?: string | undefined;
  supplier?: string | undefined;
  tenant?: OD3_Tenant | undefined;
}

export class SIV_GoodsReceiving extends Parse.Object<SIV_GoodsReceivingAttributes> {
  static className: string = "SIV_GoodsReceiving";

  constructor(data?: Partial<SIV_GoodsReceivingAttributes>) {
    super("SIV_GoodsReceiving", data as SIV_GoodsReceivingAttributes);
  }

  get amount(): number | undefined {
    return super.get("amount");
  }
  set amount(value: number | undefined) {
    super.set("amount", value);
  }

  get changedAt(): Date | undefined {
    return super.get("changedAt");
  }
  set changedAt(value: Date | undefined) {
    super.set("changedAt", value);
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get date(): Date | undefined {
    return super.get("date");
  }
  set date(value: Date | undefined) {
    super.set("date", value);
  }

  get deliveryNote(): SIV_DeliveryNotes | undefined {
    return super.get("deliveryNote");
  }
  set deliveryNote(value: SIV_DeliveryNotes | undefined) {
    super.set("deliveryNote", value);
  }

  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }

  get directory(): string | undefined {
    return super.get("directory");
  }
  set directory(value: string | undefined) {
    super.set("directory", value);
  }

  get directoryDate(): Date | undefined {
    return super.get("directoryDate");
  }
  set directoryDate(value: Date | undefined) {
    super.set("directoryDate", value);
  }

  get filler(): string | undefined {
    return super.get("filler");
  }
  set filler(value: string | undefined) {
    super.set("filler", value);
  }

  get goodsReceiptProcess(): SIV_GoodsReceiptProcess | undefined {
    return super.get("goodsReceiptProcess");
  }
  set goodsReceiptProcess(value: SIV_GoodsReceiptProcess | undefined) {
    super.set("goodsReceiptProcess", value);
  }

  get no(): string {
    return super.get("no");
  }
  set no(value: string) {
    super.set("no", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get order(): SIV_Order {
    return super.get("order");
  }
  set order(value: SIV_Order) {
    super.set("order", value);
  }

  get project(): string | undefined {
    return super.get("project");
  }
  set project(value: string | undefined) {
    super.set("project", value);
  }

  get storageLocation(): string | undefined {
    return super.get("storageLocation");
  }
  set storageLocation(value: string | undefined) {
    super.set("storageLocation", value);
  }

  get supplier(): string | undefined {
    return super.get("supplier");
  }
  set supplier(value: string | undefined) {
    super.set("supplier", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("SIV_GoodsReceiving", SIV_GoodsReceiving);
